/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { ResponseEnvelope } from './ResponseEnvelope'
import type { TradingChallengeResultsResponseEnvelope } from './TradingChallengeResultsResponseEnvelope'

export type GetTradingChallengeResultsPath = {
  /**
   * @description
   * Format: `uuid`
   * @type string
   */
  trading_challenge_id: string
}

export const getTradingChallengeResultsBoard = {
  TOP_PNL: 'TOP_PNL',
  TOP_VOLUME: 'TOP_VOLUME',
  IRON_TRADER: 'IRON_TRADER',
} as const

export type GetTradingChallengeResultsBoard =
  (typeof getTradingChallengeResultsBoard)[keyof typeof getTradingChallengeResultsBoard]

export type GetTradingChallengeResultsQuery = {
  /**
   * @description Leaderboard board selector. Defaults to TOP_PNL.
   * @default 'TOP_PNL'
   * @type string | undefined
   */
  board?: GetTradingChallengeResultsBoard
}

export type GetTradingChallengeResultsStatus200 = TradingChallengeResultsResponseEnvelope

/**
 * @description Standard response envelope. For 2xx responses, \'data\' is set. For errors, \'error\' is set.
 * @type object
 */
export type GetTradingChallengeResultsStatus400 = ResponseEnvelope

/**
 * @description Standard response envelope. For 2xx responses, \'data\' is set. For errors, \'error\' is set.
 * @type object
 */
export type GetTradingChallengeResultsStatus404 = ResponseEnvelope

/**
 * @description Standard response envelope. For 2xx responses, \'data\' is set. For errors, \'error\' is set.
 * @type object
 */
export type GetTradingChallengeResultsStatus500 = ResponseEnvelope

export type GetTradingChallengeResultsOptions = {
  body?: never
  path: GetTradingChallengeResultsPath
  query?: GetTradingChallengeResultsQuery
  headers?: never
}

export type GetTradingChallengeResultsResponses = {
  '200': GetTradingChallengeResultsStatus200
  '400': GetTradingChallengeResultsStatus400
  '404': GetTradingChallengeResultsStatus404
  '500': GetTradingChallengeResultsStatus500
}

/**
 * @description Union of all possible responses
 */
export type getTradingChallengeResultsOperationResponse = GetTradingChallengeResultsStatus200
